import React, { Component } from 'react'

import AlertBanner from 'components/alerts/alert-banner'
import ListHeading from 'components/list-heading/list-heading'

import { Draggable, Droppable, DragDropContext } from 'react-beautiful-dnd'

import { clone } from 'lodash'

export default class ListContainer extends Component {
	state = {
		sortingData: {
			column: this.props.columns[0].slug,
			direction: 'asc'
		},
		hasMounted: false
	}

	componentDidMount() {
		setTimeout(_ => {
			this.setState({
				hasMounted: true
			})
		}, 5)
	}

	setSorting = column => {
		const {
			sortingData
		} = this.state

		let direction = 'asc'

		if (sortingData.column === column) {
			direction = sortingData.direction == 'asc' ? 'desc' : 'asc'
		}

		const newSortingData = {
			column,
			direction
		}

		this.setState({
			sortingData: newSortingData
		})
	}

	getSearchValue = item => {
		const {
			type
		} = this.props

		let searchValue = ''

		switch (type) {
			case 'team':
				searchValue = item.name.toLowerCase()
				break
			case 'meeting':
				searchValue = item.start_date

				if (item.project) {
					searchValue += ' ' + item.project.name
				}

				if (item.location) {
					searchValue += ' ' + item.location
				}

				if (item.stakeholder) {
					searchValue += ' ' + item.stakeholder
				}

				if (item.purposes) {
					searchValue += ' ' + item.purposes
				}

				if (item.contact_type) {
					searchValue += ' ' + item.contact_type.name
				}
				break
			default:
				if (item.recipient_email) {
					searchValue = item.recipient_email
				} else {
					if (item.first_name) {
						searchValue += item.first_name.toLowerCase() + ' '
					}

					if (item.last_name) {
						searchValue += item.last_name.toLowerCase() + ' '
					}

					if (item.organisation_name) {
						searchValue += item.organisation_name
					}
				}
				break
		}

		return searchValue

	}

	getClassName = _ => {
		const {
			type,
			isGrid,
			columns,
			shouldBlockTransition
		} = this.props

		const {
			hasMounted
		} = this.state

		let className = ''

		switch (type) {
			case 'team':
				className = 'team-list'

				break
			default:
				className = 'users-list'

				if (isGrid) {
					className += ' grid'
				} else {
					className += ' list'
				}

				break
		}

		if (shouldBlockTransition) {
			className += ' block-transition'
		}

		if (!hasMounted) {
			className += ' hidden'
		}

		className += ' columns-' + columns.length

		return className
	}

	onDragStart = _ => {

	}

	onDragEnd = result => {
		if(!result.destination){
			return
		}

		const { items, updateTeamOrder } = this.props

		const draggableId = parseInt(result.draggableId)
		const newIndex = result.destination.index

		if (result.destination) {
			const updatedItems = []

			const allItems = items.map(account => {
				return account.id
			})

			allItems.splice(allItems.indexOf(draggableId), 1)
			allItems.splice(newIndex, 0, draggableId)

			allItems.forEach(id => {
				updatedItems.push(id)
			})

			updateTeamOrder(updatedItems)
		}
	}

	render() {
		const {
			unit,
			type,
			emptyTitle,
			emptyCopy,
			canSort,
			columns,
			isGrid,
			searchTerm,
			unitProps
		} = this.props

		let {
			items
		} = this.props

		const {
			sortingData,
		} = this.state

		const isDraggable = type === 'team'

		const listClassName = this.getClassName()

		if (!items.length) {
			return (
				<AlertBanner
					title={emptyTitle}
					body={emptyCopy}
				/>
			)
		}

		if (canSort) {
			const getter = columns.find(column => {
				return column.slug == sortingData.column
			}).getter

			items = items.sort((a, b) => {
				let aText = getter(a)
				let bText = getter(b)
				let tempText // in case we need to swap 'em

				if (sortingData.direction == 'desc') {
					tempText = aText
					aText = bText
					bText = tempText
				}

				if (sortingData.column.includes('date')) {
					return aText.localeCompare(bText)
				} else {
					if (aText.toLowerCase() < bText.toLowerCase()) return -1
					if (aText.toLowerCase() > bText.toLowerCase()) return 1
					return 0
				}
			})
		}

		let renderedIndex = -1

		if(isDraggable){
			items = items.sort((a,b) => {
				return a.order - b.order
			})
		}

		const itemsJsx = items.filter(Boolean).map((listItem, index) => {
			const email = listItem.email ? listItem.email : ''
			let searchValue = this.getSearchValue(listItem)

			if (email) {
				searchValue += ' ' + email
			}

			if (searchTerm && !searchValue.toLowerCase().includes(searchTerm.toLowerCase())) {
				return null
			}

			renderedIndex++

			const thisRenderedIndex = clone(renderedIndex)

			const Unit = unit

			return (
				<Unit
					{...unitProps}
					key={index}
					item={listItem}
					index={thisRenderedIndex}
				/>
			)
		})

		return (
			<DragDropContext onDragStart={this.onDragStart} onDragEnd={this.onDragEnd}>
				<ul className={listClassName}>
					{type != 'team' ?
						<ListHeading
							columns={columns}
							sortingData={sortingData}
							setSorting={this.setSorting}
							isVisible={!isGrid}
						/>
						: null}
					{isDraggable ?
						<Droppable
							droppableId={'team'}
							type="TEAM"
						>
							{provided => (
								<div
									ref={provided.innerRef}
								>
									{ itemsJsx.map((item, index) => {										
										return (
											<div
												key={index}
											>
												<Draggable
													disableInteractiveElementBlocking={false}
													index={index}
													draggableId={item.props.item.id}
													type="TEAM"
												>
													{provided => (
														<div
															ref={provided.innerRef}
															{...provided.draggableProps}
															{...provided.dragHandleProps}
														>
															{ item}
														</div>
													)}
												</Draggable>
											</div>
										)
									})}
								</div>
							)}
						</Droppable>
						: itemsJsx}
				</ul>
			</DragDropContext>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/list-container/list-container.jsx